import { render, staticRenderFns } from "./RequestReExam.vue?vue&type=template&id=63b7509b&"
import script from "./RequestReExam.vue?vue&type=script&lang=js&"
export * from "./RequestReExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports